import React from 'react';
import './App.scss';
import { Layout, Menu, Icon, Divider, Button } from 'antd';
import { BrowserRouter as Router, Route, Link, withRouter } from "react-router-dom";
import LoginForm from './components/auth/login/login';
import ActivityList from './components/agenda/activity-list/activity-list';
import Activity from './components/agenda/activity/activity';
import AddAgenda from './components/agenda/add/add-agenda';
import { getCurrentUser, isPhone } from './utils/utils';
import Users from './components/config/users/users';
import AllActivities from './components/agenda/all-activies/all-activities';

const { Content, Sider, Header } = Layout;
const { SubMenu } = Menu;

class App extends React.Component {

  state = {
    collapsed: isPhone(),
    checkAuth: false,
    defaultRoute: this.props.route
  };

  agendaProps = {
    fields: ['title', 'municipality', 'location', 'sector', 'address', 'position', 'organism', 'description', 'pic-wall', 'date', 'submit'],
    mode: 'agenda',
    title: 'Agendar actividad'
  };

  planificationProps = {
    fields: ['title', 'price', 'municipality', 'location', 'sector', 'organism', 'description',
      'pic-wall', 'lat', 'lng', 'meta', 'measurement', 'exec_lapses', 'submit'],
    mode: 'planificacion',
    title: 'Planificación de proyectos'
  };

  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  componentDidMount() {
    this.setState({ checkAuth: localStorage.getItem('token') ? true : false });
  }

  logout = () => {
    const { history } = this.props;
    localStorage.clear();
    history.push('/login');
    window.location.reload();
  }

  render() {

    return (
      <Router>
        <Layout>
          {(this.state.defaultRoute !== 'login' || isPhone()) &&
            <Header theme="light" className="header-bar">
              <div className="menu-title" style={{ width: this.state.collapsed ? (isPhone() ? '100vw' : '80px') : (isPhone() ? '100vw' : '248px') }}>
                <span style={{ fontWeight: 'bold', fontSize: this.state.collapsed ? (isPhone() ? '25px' : '15px') : '25px' }}>SIFOGE</span>
              </div>
            </Header>
          }
          <Layout style={{ height: isPhone() ? '100vh' : '93vh' }}>

            {this.state.defaultRoute !== 'login' && this.sider()}
            < Layout >
              <Content style={{ margin: (isPhone() ? '16px 0px' : '16px 16px'), width: this.state.collapsed ? (isPhone() ? '100vw' : 'calc(100vw - 130px)') : 'calc(100vw - 300px)' }} >

                <Route exact path="/config/usuarios" component={this.state.defaultRoute === 'login' ? LoginForm : Users} />

                <Route exact path="/agenda/listado" component={this.state.defaultRoute === 'login' ? LoginForm : AllActivities} />

                <Route exact path="/login" component={this.state.defaultRoute === 'login' ? LoginForm : LoginForm} />

                <Route path="/actividad" component={this.state.defaultRoute === 'login' ? LoginForm : Activity} />

                <Route path="/agenda/nueva" render={(routeProps) => (
                  this.state.defaultRoute === 'login' ? LoginForm : <AddAgenda {...routeProps} {...this.agendaProps} />
                )} />

                <Route path="/planificacion/nueva" render={(routeProps) => (
                  this.state.defaultRoute === 'login' ? LoginForm : <AddAgenda {...routeProps} {...this.planificationProps} />
                )} />

                <Route path="/mi-planificacion" component={this.state.defaultRoute === 'login' ? LoginForm : ActivityList} />

                <Route exact path="/" component={this.state.defaultRoute === 'login' ? LoginForm : ActivityList} />

              </Content>
            </Layout >
          </Layout >
        </Layout>
      </Router>
    );
  }

  sider = () => {

    const { collapsed } = this.state;

    const menuCollection = [
      {
        type: 'sub', icon: 'calendar', text: 'Agenda semanal', permission: [1, 2, 3, 4], menus: [
          { type: 'menu', icon: 'plus', text: 'Agendar', route: '/agenda/nueva', permission: [1, 2, 3, 4] },
          { type: 'menu', icon: 'schedule', text: 'Mi agenda', route: '/mi-planificacion', permission: [1, 2, 3, 4] },
          { type: 'menu', icon: 'ordered-list', text: 'Listado', route: '/agenda/listado', permission: [1, 2, 3, 4] },
        ],
      },
      {
        type: 'sub', icon: 'calendar', text: 'Gestión', permission: [1, 2, 3, 4], menus: [
          { type: 'menu', icon: 'plus', text: 'Planificar', route: '/planificacion/nueva', permission: [1, 2, 3, 4] },
          { type: 'menu', icon: 'schedule', text: 'Mi planificación', route: '/mi-planificacion', permission: [1, 2, 3, 4] },
        ],
      },
      {
        type: 'sub', icon: 'setting', text: 'Configuración', permission: [2], menus: [
          { type: 'menu', icon: 'user', text: 'Usuarios', route: '/config/usuarios', permission: [2] },
        ],
      },
    ];

    return (
      <Sider className="sider" width={isPhone() ? "90vw" : "250px"} collapsible collapsed={collapsed} collapsedWidth={isPhone() ? '0px' : '80px'} onCollapse={this.onCollapse}>
        <Menu defaultSelectedKeys={['1']} mode="inline">
          <div className="menu-header">
            <div>
              <span>{getCurrentUser().username}</span>
            </div>
            <div className="user-options">
              {!this.state.collapsed && <Button type="primary" shape="circle" icon="user" />}
              {!this.state.collapsed && <Divider type={this.state.collapsed ? "horizontal" : "vertical"} />}
              <Button className="logout-button" onClick={this.logout} shape="circle" icon="logout" />
            </div>
            <Divider type="horizontal" />
          </div>
          {
            menuCollection.map(
              (menu, i) => {
                if (menu.type === 'menu' && menu.permission.includes(getCurrentUser().role)) {
                  return (
                    <Menu.Item key={i} className="menu-item">
                      <Link to={menu.route}>
                        <Icon type={menu.icon}></Icon>
                        <span>{menu.text}</span>
                      </Link>
                    </Menu.Item>
                  )
                } else if (menu.permission.includes(getCurrentUser().role)) {
                  return (
                    <SubMenu
                      key={i}
                      title={
                        <span>
                          <Icon type={menu.icon}></Icon>
                          <span>{menu.text}</span>
                        </span>}>
                      {menu.menus.map(
                        (sub, j) => {
                          return (
                            <Menu.Item key={`sub_${i}_${j}`} className="sub-menu-item">
                              <Link to={sub.route}>
                                <Icon type={sub.icon}></Icon>
                                <span>{sub.text}</span>
                              </Link>
                            </Menu.Item>
                          )
                        }
                      )}
                    </SubMenu>
                  )
                } else { return null; }
              }
            )
          }

        </Menu>
      </Sider>
    );
  }

}

export default withRouter(App);
